import { Controller } from "@hotwired/stimulus"

// Refresh delivery history without replacing the buyer's message form.
export default class extends Controller {
  connect() {
    this.timer = window.setTimeout(() => this.element.closest("turbo-frame").reload(), 3000)
  }

  disconnect() {
    window.clearTimeout(this.timer)
  }
}
